module.exports = __webpack_public_path__ + "img/88.955c749f.png";